import { render } from "./BotLogList.vue?vue&type=template&id=a48cb55a&scoped=true"
import script from "./BotLogList.vue?vue&type=script&lang=js"
export * from "./BotLogList.vue?vue&type=script&lang=js"

import "./BotLogList.vue?vue&type=style&index=0&id=a48cb55a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a48cb55a"]])

export default __exports__